module.exports = __webpack_public_path__ + "img/goinfolder.d9d0066a.svg";